import type { FC } from 'react'

import type { SxProps, Theme } from '@mui/material'
import { Typography } from '@mui/material'

interface BlinkingCursorProps {
  readonly character?: string
  readonly color?: string
  readonly fontSize?: string
}

export const BlinkingCursor: FC<BlinkingCursorProps> = ({
  character = '|',
  color = 'primary.main',
  fontSize = '2.5rem',
}) => {
  return (
    <Typography component="span" sx={buildCursorSx(color, fontSize)}>
      {character}
    </Typography>
  )
}

const buildCursorSx = (color: string, fontSize: string): SxProps<Theme> => ({
  color,
  fontSize,
  fontWeight: 400,
  '@media (prefers-reduced-motion: no-preference)': {
    '@keyframes blink': {
      '0%, 100%': { opacity: 1 },
      '50%': { opacity: 0 },
    },
    animation: 'blink 1s step-end infinite',
  },
})
